// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  display: flex;
  overflow: auto;
  position: relative;
}

:host,
.content {
  flex: 1 1 0%;
}

.content {
  margin-right: 7px;
  overflow: auto;
  overflow-anchor: none;
}

.embed .convo {
  padding: 0;
}
.embed .turn {
  padding: 1rem 0.25rem 0;
}

.convo {
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-bottom: 1rem;
}

.load-more-container {
  display: flex;
  justify-content: center;
  padding: 1rem;
}
.load-more-container .load-more-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.load-more-container .load-more-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.load-more-container .load-more-button mat-spinner {
  margin-right: 0.25rem;
}

.turn {
  padding: calc(var(--density-spacing, 1rem) + 2px) 0px;
  font-size: 1rem;
  line-height: 1.5rem;
}
.turn .streaming-cursor {
  white-space: pre-wrap;
}
.turn:last-child {
  padding-bottom: 0;
}
@media (min-width: 1200px) {
  .turn {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
@media (min-width: 992px) {
  .turn {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}
@media (min-width: 768px) {
  .turn {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

.center-col {
  margin: 0 auto;
  width: 100%;
  max-width: var(--message-max-width, 800px);
  display: flex;
  justify-content: flex-start;
  gap: var(--density-spacing, 1rem);
}
.center-col.self {
  justify-content: flex-end;
}
@media (min-width: 992px) {
  .center-col {
    gap: calc(var(--density-spacing, 1rem) + 0.5rem);
  }
}
@media (min-width: 768px) {
  .center-col {
    gap: calc(var(--density-spacing, 1rem) + 0.25rem);
  }
}

.other-gutter {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 50%;
  border-width: 1px;
  border-style: solid;
  padding: 6px;
  height: 32px;
  width: 32px;
  font-size: 18px;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
}

.self-message {
  padding: 0.652rem 1.25rem;
  border-radius: 1.5rem;
  max-width: 70%;
}

.other-message {
  padding-top: 4px;
}
.other-message.error {
  color: unset;
  border-width: 1px;
  border-style: solid;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
}

/* Error container for messages that ended with errors */
.error-container {
  width: 100%;
}
.error-container .error-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  margin-top: 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
}
.error-container .error-banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* Light theme error banner */
:host-context(.light-theme) .error-banner,
.error-banner {
  background-color: #fdecea;
  color: #c62828;
  border: 1px solid #f5c6cb;
}

/* Dark theme error banner */
:host-context(.dark) .error-banner {
  background-color: rgba(198, 40, 40, 0.15);
  color: #ef9a9a;
  border: 1px solid rgba(198, 40, 40, 0.3);
}

/* Cancelled container — same layout as error but amber tint */
.cancelled-container {
  width: 100%;
}
.cancelled-container .cancelled-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  margin-top: 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
}
.cancelled-container .cancelled-banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

:host-context(.light-theme) .cancelled-banner,
.cancelled-banner {
  background-color: #fff8e1;
  color: #f57f17;
  border: 1px solid #ffe082;
}

:host-context(.dark) .cancelled-banner {
  background-color: rgba(255, 160, 0, 0.12);
  color: #ffcc80;
  border: 1px solid rgba(255, 160, 0, 0.3);
}

.title {
  font-weight: bold;
}

hr {
  width: 80%;
  border-top: 1px solid #eee;
  margin-bottom: 30px;
  margin-top: 0;
}

.timestamp {
  font-size: 0.75rem;
  color: #999;
  margin-left: 8px;
}

.title {
  display: flex;
  align-items: center;
}

.flex-spacer {
  flex-grow: 1;
  min-width: 0;
}

.timestamp {
  font-size: 0.85rem;
  color: #888;
}

/* ---- MESSAGE BUBBLE STYLING ---- */
.message-bubble {
  position: relative;
  padding: 0.652rem 1.25rem;
  border-radius: 1.5rem;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}
.message-bubble.self-message {
  max-width: 70%;
}

.status-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 0;
  opacity: 0.5;
  font-size: 0.75rem;
  -webkit-user-select: none;
          user-select: none;
}
.status-divider .material-icons {
  font-size: 14px;
}
.status-divider .status-text {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.status-divider .status-time {
  opacity: 0.7;
}
.status-divider .status-time::before {
  content: "·";
  margin-right: 6px;
}

.self-message {
  background: #e3f2fd; /* Light blue for self messages */
}

.other-message {
  background: #f5f5f5; /* Light gray for others */
}

/* ---- HEADER STYLING (Title, Timestamp, Copy Button) ---- */
.message-header {
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  min-width: 0;
  overflow: hidden;
}

.title-text {
  font-weight: bold;
}

.flex-spacer {
  flex-grow: 1;
  min-width: 0;
}

.timestamp {
  font-size: 0.85rem;
  color: #888;
}

.model {
  font-size: 0.85rem;
  color: #888;
}

.copy-button {
  --square-button-size: 30px;
  --square-icon-size: 15px;
}

.header-fav {
  font-family: "SF Mono", "Monaco", "Inconsolata", "Roboto Mono", monospace;
  font-size: 0.8rem;
  opacity: 1;
  padding: 2px 6px;
  border-radius: 4px;
  -webkit-user-select: none;
          user-select: none;
  display: inline-flex;
  align-items: center;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}
.header-fav .fav-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.header-fav .fav-icon.pin-active {
  color: var(--tool-accent, #1976d2);
  opacity: 1;
}
.header-fav.agent-badge {
  color: var(--tool-accent, #1976d2);
  font-weight: 500;
  font-family: inherit;
}
.header-fav.orchestration-badge {
  color: var(--orchestration-accent, #ab47bc);
  font-weight: 500;
  font-family: inherit;
}
.header-fav[class*=-badge]:not(.duration-badge):not(.tokens-badge):not(.model-badge):not(.agent-badge) {
  cursor: pointer;
}
.header-fav[class*=-badge]:not(.duration-badge):not(.tokens-badge):not(.model-badge):not(.agent-badge):hover {
  opacity: 0.9;
  background-color: rgba(128, 128, 128, 0.15);
}
.header-fav.duration-badge .fcp-secondary {
  opacity: 0.5;
  font-weight: 400;
}

::ng-deep .fav-menu-item .mdc-list-item__primary-text,
::ng-deep .fav-menu-item .mat-mdc-menu-item-text {
  display: flex !important;
  align-items: center;
  width: 100%;
  gap: 4px;
}
::ng-deep .fav-menu-item .fav-spacer {
  flex: 1 1 0;
  min-width: 8px;
}
::ng-deep .fav-menu-item .reorder-arrow {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
::ng-deep .fav-menu-item .reorder-arrow.disabled {
  cursor: default;
}
::ng-deep .fav-menu-item:hover .reorder-arrow {
  opacity: 0.3;
}
::ng-deep .fav-menu-item:hover .reorder-arrow:hover:not(.disabled) {
  opacity: 1;
}
::ng-deep .fav-menu-item:hover .reorder-arrow.disabled {
  opacity: 0.1;
}
::ng-deep .fav-menu-item .fav-star {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.35;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
::ng-deep .fav-menu-item .fav-star:hover {
  opacity: 1;
}

.message-content {
  padding-top: 4px;
  min-width: 0;
  overflow-x: auto;
}
.message-content ::ng-deep pre {
  max-width: 100%;
  overflow-x: auto;
}
.message-content ::ng-deep a[href*="/channel-uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]),
.message-content ::ng-deep a[href*="/uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]) {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: inherit !important;
  text-decoration: none !important;
  font-size: 0.9em;
  font-weight: 500;
  transition: background 0.15s ease;
  margin: 4px 0;
  cursor: pointer;
}
.message-content ::ng-deep a[href*="/channel-uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"])::before,
.message-content ::ng-deep a[href*="/uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"])::before {
  content: "\\e226";
  font-family: "Material Icons";
  font-size: 18px;
}
.message-content ::ng-deep a[href*="/channel-uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]):hover,
.message-content ::ng-deep a[href*="/uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]):hover {
  background: rgba(0, 0, 0, 0.22);
}

.square-button {
  width: var(--square-button-size, 48px);
  height: var(--square-button-size, 48px);
  padding: calc(var(--square-button-size, 48px) / 2 - var(--square-icon-size, 24px));
  padding: 0;
  border-radius: 0.5rem;
}
.square-button mat-icon {
  width: var(--square-icon-size, 24px);
  height: var(--square-icon-size, 24px);
  line-height: var(--square-icon-size, 24px);
  font-size: var(--square-icon-size, 24px);
}
.square-button ::ng-deep .mat-mdc-button-persistent-ripple {
  border-radius: 0.5rem;
}
.square-button ::ng-deep .mat-mdc-button-touch-target {
  width: var(--square-button-size, 48px);
  height: var(--square-button-size, 48px);
}

.wide {
  width: 100%;
  min-width: 700px;
  height: auto;
  max-height: 600px;
  overflow-y: auto;
}

.hidden {
  display: none;
}

/* Add animation for the blinking cursor in streaming text */
@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.streaming-cursor::after {
  content: "|";
  display: inline-block;
  margin-left: 2px;
  animation: blink 1s step-start infinite;
  color: #444;
  font-weight: bold;
}

/* Typing indicator animation */
.typing-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 8px 12px;
  cursor: pointer;
  position: relative;
}
.typing-indicator .spinner-line {
  margin-right: auto;
  font-family: "SF Mono", "Roboto Mono", "Menlo", monospace;
  font-size: 0.85em;
  color: #9aa0a6;
  white-space: pre-wrap;
  word-break: break-word;
  animation: spinner-line-pulse 1.6s ease-in-out infinite;
}
.typing-indicator .stop-icon {
  position: absolute;
  right: 4px;
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0;
  color: #999;
  transition: opacity 0.15s;
}
.typing-indicator:hover .dot {
  animation-play-state: paused;
  opacity: 0.3;
}
.typing-indicator:hover .stop-icon {
  opacity: 1;
}
.typing-indicator .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #888;
  margin: 0 4px;
  opacity: 0.6;
  animation: dot-pulse 1.5s ease-in-out infinite;
}
.typing-indicator .dot:nth-child(1) {
  animation-delay: 0s;
}
.typing-indicator .dot:nth-child(2) {
  animation-delay: 0.3s;
}
.typing-indicator .dot:nth-child(3) {
  animation-delay: 0.6s;
}

.typing-indicator--connecting .dot {
  background-color: #bbb;
}

.typing-indicator--generating .dot {
  background-color: #1976d2;
}

.typing-indicator--stalled .dot {
  background-color: #ff9800;
}

@keyframes dot-pulse {
  0%, 60%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  30% {
    transform: scale(1.5);
    opacity: 1;
  }
}
@keyframes spinner-line-pulse {
  0%, 100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}
/* ---- READ RECEIPTS ---- */
.read-receipt {
  display: flex;
  justify-content: flex-end;
  padding: 0 4px;
  margin-top: -2px;
}
.read-receipt .receipt-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  opacity: 0.35;
  color: inherit;
}
.read-receipt .receipt-icon.read {
  opacity: 0.8;
  color: #4caf50;
}

/* ---- IMAGE LIGHTBOX ---- */
.image-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  cursor: pointer;
}
.image-lightbox.active {
  opacity: 1;
  visibility: visible;
}
.image-lightbox img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}
.image-lightbox .image-lightbox-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: white;
  cursor: pointer;
  transition: color 0.2s ease;
  line-height: 1;
}
.image-lightbox .image-lightbox-close:hover {
  color: #ccc;
}

/* Make images in messages clickable and properly sized */
.message-content ::ng-deep img {
  cursor: pointer;
  transition: opacity 0.15s ease;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 8px;
}
.message-content ::ng-deep img:hover {
  opacity: 0.85;
}

/* Mobile responsive - prevent horizontal overflow */
@media (max-width: 768px) {
  :host {
    max-width: 100vw;
    overflow-x: hidden;
  }
  .content {
    margin-right: 0;
    max-width: 100vw;
    overflow-x: hidden;
  }
  .wide {
    min-width: unset !important;
    width: 100% !important;
    max-width: 100vw;
  }
  .turn {
    padding-left: 8px;
    padding-right: 8px;
  }
  .center-col {
    max-width: 100%;
  }
  .message-bubble {
    max-width: 100%;
  }
  .self-message {
    max-width: 85%;
  }
  .other-message {
    max-width: 100%;
    overflow-x: hidden;
    word-break: break-word;
  }
  .message-content ::ng-deep pre, .message-content ::ng-deep code {
    max-width: 100%;
    overflow-x: auto;
    word-break: break-word;
  }
  .message-content ::ng-deep img {
    max-width: 100%;
    height: auto;
  }
}
.widget-container {
  position: relative;
  height: 400px;
  min-height: 200px;
  max-height: none;
  resize: vertical;
  overflow: auto;
}
.widget-container ::ng-deep app-widget-titlebar {
  display: none;
}

.widget-toolbar-slot {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 8px;
}
.widget-toolbar-slot ::ng-deep .tab-buttons {
  display: flex;
  gap: 2px;
}
.widget-toolbar-slot ::ng-deep button {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
}
.widget-toolbar-slot ::ng-deep button:hover {
  opacity: 1;
  background: rgba(128, 128, 128, 0.2);
}
.widget-toolbar-slot ::ng-deep button.active {
  opacity: 1;
  background: rgba(128, 128, 128, 0.3);
}
.widget-toolbar-slot ::ng-deep button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.widget-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--surface-color, rgba(255, 255, 255, 0.95));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  z-index: 10;
}
.widget-loading-overlay span {
  font-size: 0.875rem;
  color: var(--text-secondary, #666);
}

.kebab-button {
  --square-button-size: 30px;
  --square-icon-size: 15px;
}

.snapshot-button {
  --square-button-size: 30px;
  --square-icon-size: 15px;
}

.pin-button {
  --square-button-size: 30px;
  --square-icon-size: 15px;
}
.pin-button mat-icon {
  transform: rotate(45deg);
  transition: transform 0.15s ease, color 0.15s ease;
}
.pin-button.pin-active mat-icon {
  transform: rotate(0deg);
  color: var(--tool-accent, #1976d2);
}

.turn.highlight-flash .message-bubble {
  animation: highlight-pulse 2s ease-out;
}

@keyframes highlight-pulse {
  0% {
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.4);
  }
  100% {
    box-shadow: none;
  }
}
.snapshot-preview {
  position: fixed;
  z-index: 1000;
  width: 200px;
  background: var(--surface-color, white);
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  pointer-events: none;
}
.snapshot-preview .preview-label {
  padding: 6px 10px;
  background: var(--surface-color, #f5f5f5);
  font-size: 0.7rem;
  color: var(--text-secondary, #666);
  border-bottom: 1px solid var(--border-color, #e0e0e0);
}
.snapshot-preview img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: cover;
}

.widget-screenshot {
  margin-top: 8px;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  overflow: hidden;
  cursor: default;
}
.widget-screenshot img {
  display: block;
  width: 100%;
  height: auto;
}

.message-footer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
}

.links-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-shrink: 0;
  margin-left: auto;
}

.link-tag {
  display: inline-block;
  font-size: 11px;
  color: rgba(140, 180, 220, 0.85);
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(140, 180, 220, 0.1);
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: color 0.15s ease, background 0.15s ease;
}
.link-tag:hover {
  color: rgb(140, 180, 220);
  background: rgba(140, 180, 220, 0.18);
}
.link-tag.backlog-tag {
  color: #ffc777;
  background: rgba(255, 199, 119, 0.12);
}
.link-tag.backlog-tag:hover {
  color: #ffd89e;
  background: rgba(255, 199, 119, 0.2);
}
.link-tag.concept-tag {
  color: rgba(100, 180, 255, 0.85);
  background: rgba(100, 180, 255, 0.1);
}
.link-tag.product-tag {
  color: rgba(130, 220, 160, 0.85);
  background: rgba(130, 220, 160, 0.1);
}
.link-tag.people-tag {
  color: rgba(255, 180, 130, 0.85);
  background: rgba(255, 180, 130, 0.1);
}
.link-tag.ticket-tag {
  color: rgba(220, 140, 255, 0.85);
  background: rgba(220, 140, 255, 0.1);
}
.link-tag.channel-tag {
  color: rgba(100, 220, 220, 0.85);
  background: rgba(100, 220, 220, 0.1);
}
.link-tag.editing {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px 4px;
  background: rgba(140, 180, 220, 0.15);
  border: 1px solid rgba(140, 180, 220, 0.3);
}

.tag-edit-input {
  background: transparent;
  border: none;
  outline: none;
  color: inherit;
  font-size: 11px;
  font-family: inherit;
  letter-spacing: 0.02em;
  width: 120px;
  padding: 0;
}

.tag-delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.5;
  border-radius: 50%;
  transition: opacity 0.15s ease, background 0.15s ease;
}
.tag-delete-btn mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
  line-height: 12px;
}
.tag-delete-btn:hover {
  opacity: 1;
  background: rgba(255, 80, 80, 0.2);
}

.add-tag-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px dashed rgba(140, 180, 220, 0.3);
  background: transparent;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
  padding: 0;
}
.add-tag-btn mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  opacity: 0.5;
}
.add-tag-btn:hover {
  background: rgba(140, 180, 220, 0.1);
}
.add-tag-btn:hover mat-icon {
  opacity: 0.9;
}

.message-bubble:hover .add-tag-btn {
  opacity: 1;
}

::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel .mat-mdc-option {
  font-size: 11px;
  min-height: 28px;
  padding: 0 10px;
  line-height: 28px;
}

.reactions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  position: relative;
  flex: 1;
  min-width: 0;
}

.reaction-pill {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid var(--preset-text-muted, rgba(128, 128, 128, 0.25));
  background: var(--preset-code, rgba(128, 128, 128, 0.08));
  cursor: pointer;
  font-size: 0.85rem;
  line-height: 1.4;
  transition: border-color 0.15s ease, background 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
}
.reaction-pill:hover {
  border-color: var(--preset-primary, #2aa198);
  background: var(--preset-card, rgba(128, 128, 128, 0.15));
}
.reaction-pill.mine {
  background: color-mix(in srgb, var(--preset-primary, #2aa198) 12%, transparent);
}
.reaction-pill .reaction-emoji {
  font-size: 1rem;
  line-height: 1;
}
.reaction-pill .reaction-count {
  font-size: 0.75rem;
  opacity: 0.7;
}

.add-reaction-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px dashed var(--preset-text-muted, rgba(128, 128, 128, 0.3));
  background: transparent;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
  padding: 0;
}
.add-reaction-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  opacity: 0.5;
}
.add-reaction-btn:hover {
  background: var(--preset-code, rgba(128, 128, 128, 0.1));
}
.add-reaction-btn:hover mat-icon {
  opacity: 0.9;
}

.self-message .link-tag {
  color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.15);
}
.self-message .link-tag:hover {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.25);
}
.self-message .link-tag.backlog-tag {
  color: #ffc777;
  background: rgba(255, 199, 119, 0.2);
}
.self-message .link-tag.editing {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.self-message .add-tag-btn {
  border-color: rgba(255, 255, 255, 0.3);
}
.self-message .add-tag-btn mat-icon {
  color: rgba(255, 255, 255, 0.7);
}
.self-message .add-tag-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.self-message .tag-edit-input {
  color: white;
}

.self-message .reaction-pill {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}
.self-message .reaction-pill:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}
.self-message .reaction-pill.mine {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.self-message .add-reaction-btn {
  border-color: rgba(255, 255, 255, 0.3);
}
.self-message .add-reaction-btn mat-icon {
  color: rgba(255, 255, 255, 0.7);
}
.self-message .add-reaction-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.message-bubble:hover .add-reaction-btn {
  opacity: 1;
}

.reactions-row:has(.reaction-picker) .add-reaction-btn {
  opacity: 1;
}

.reaction-picker {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  border-radius: 20px;
  background: var(--preset-card, #fff);
  border: 1px solid var(--preset-text-muted, rgba(128, 128, 128, 0.2));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 10;
}
.reaction-picker .picker-emoji {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.15rem;
  transition: background 0.1s ease, transform 0.1s ease;
}
.reaction-picker .picker-emoji:hover {
  background: var(--preset-code, rgba(128, 128, 128, 0.12));
  transform: scale(1.15);
}
.reaction-picker .picker-emoji.selected {
  background: color-mix(in srgb, var(--preset-primary, #2aa198) 15%, transparent);
}

.scroll-to-bottom-btn {
  position: absolute;
  bottom: 30px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--primary-color, #1976d2);
  color: white;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s;
  z-index: 50;
}
.scroll-to-bottom-btn mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.scroll-to-bottom-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.scroll-to-bottom-btn:active {
  transform: scale(0.95);
}
.scroll-to-bottom-btn .new-content-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #f44336;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.truncated-card .truncated-preview {
  max-height: 200px;
  overflow: hidden;
  position: relative;
  mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
}
.truncated-card .truncated-expand-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  font-size: 12px;
  opacity: 0.8;
}
.truncated-card .truncated-expand-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.truncated-card .truncated-expand-btn:hover {
  opacity: 1;
}

.channel-actions {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.channel-action-card {
  --action-accent-color: var(--preset-primary, #5b8dd9);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border-left: 3px solid var(--action-accent-color);
  border-radius: 6px;
  background: var(--preset-card, rgba(0, 0, 0, 0.04));
}
.channel-action-card.channel-action-card--dismissed {
  display: none;
}
.channel-action-card.channel-action-card--work-session {
  --action-accent-color: var(--preset-primary, #5b8dd9);
}
.channel-action-card.channel-action-card--reopen-session {
  --action-accent-color: #8a8a8a;
}
.channel-action-card.channel-action-card--unarchive-channel {
  --action-accent-color: #8a8a8a;
}
.channel-action-card .action-header {
  display: flex;
  align-items: center;
}
.channel-action-card .action-type-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--action-accent-color);
  opacity: 0.75;
}
.channel-action-card .action-type-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}
.channel-action-card .action-body {
  flex: 1;
  min-width: 0;
}
.channel-action-card .action-title {
  font-size: 13px;
  font-weight: 500;
}
.channel-action-card .action-summary {
  font-size: 12px;
  opacity: 0.6;
  margin-top: 3px;
  line-height: 1.4;
}
.channel-action-card .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.channel-action-card .action-btn--primary {
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  color: white !important;
}
.channel-action-card .action-btn--dismiss {
  font-size: 12px;
  height: 30px;
  opacity: 0.45;
}

/* Read receipt of a follow-up folded into an earlier reply: clickable jump */
.read-receipt.handled {
  cursor: pointer;
}

.turn.jump-flash {
  animation: jump-flash 1.6s ease-out;
}

@keyframes jump-flash {
  0% {
    background: rgba(76, 110, 245, 0.18);
  }
  100% {
    background: transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat-screen/chat-screen.component.scss","webpack://./src/styles/_breakpoints.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,mJACE;EAWF,aAAA;EACA,cAAA;EACA,kBAAA;AAXF;;AAcA;;EAEE,YAAA;AAXF;;AAcA;EACE,iBAAA;EACA,cAAA;EAGA,qBAAA;AAbF;;AAiBE;EACE,UAAA;AAdJ;AAiBE;EACE,uBAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EAGA,oBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AAlBF;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlBN;AAqBI;EACE,qBAAA;AAnBN;;AAwBA;EACE,qDAAA;EACA,eAAA;EACA,mBAAA;AArBF;AAsBE;EACE,qBAAA;AApBJ;AAuBE;EACE,iBAAA;AArBJ;ACnDI;ED+DJ;IAaI,qBAAA;IACA,sBAAA;EArBF;AACF;ACzDI;ED+DJ;IAkBI,qBAAA;IACA,sBAAA;EApBF;AACF;AC/DI;ED+DJ;IAuBI,qBAAA;IACA,sBAAA;EAnBF;AACF;;AAsBA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,aAAA;EACA,2BAAA;EACA,iCAAA;AAnBF;AAqBE;EACE,yBAAA;AAnBJ;ACjFI;ED2FJ;IAaI,gDAAA;EAnBF;AACF;ACtFI;ED2FJ;IAiBI,iDAAA;EAlBF;AACF;;AAqBA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;AAqBE;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;AAnBJ;;AAuBA,wDAAA;AACA;EACE,WAAA;AApBF;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApBN;;AAyBA,6BAAA;AACA;;EAEE,yBAAA;EACA,cAAA;EACA,yBAAA;AAtBF;;AAyBA,4BAAA;AACA;EACE,yCAAA;EACA,cAAA;EACA,wCAAA;AAtBF;;AAyBA,8DAAA;AACA;EACE,WAAA;AAtBF;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtBN;;AA2BA;;EAEE,yBAAA;EACA,cAAA;EACA,yBAAA;AAxBF;;AA2BA;EACE,yCAAA;EACA,cAAA;EACA,wCAAA;AAxBF;;AA2BA;EACE,iBAAA;AAxBF;;AA2BA;EACE,UAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,YAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,WAAA;AAxBF;;AA2BA,qCAAA;AACA;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAxBF;AA0BE;EACE,cAAA;AAxBJ;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AA3BF;AA6BE;EACE,eAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,YAAA;AA7BJ;AA8BI;EACE,YAAA;EACA,iBAAA;AA5BN;;AAiCA;EACE,mBAAA,EAAA,iCAAA;AA9BF;;AAiCA;EACE,mBAAA,EAAA,0BAAA;AA9BF;;AAiCA,6DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,iBAAA;AA9BF;;AAiCA;EACE,YAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,0BAAA;EACA,wBAAA;AA9BF;;AAkCA;EACE,yEAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2DAAA;AA/BF;AAiCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/BJ;AAiCI;EACE,kCAAA;EACA,UAAA;AA/BN;AAmCE;EACE,kCAAA;EACA,gBAAA;EACA,oBAAA;AAjCJ;AAoCE;EACE,2CAAA;EACA,gBAAA;EACA,oBAAA;AAlCJ;AAqCE;EACE,eAAA;AAnCJ;AAoCI;EACE,YAAA;EACA,2CAAA;AAlCN;AAuCE;EACE,YAAA;EACA,gBAAA;AArCJ;;AA4CE;;EAEE,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAzCJ;AA4CE;EACE,WAAA;EACA,cAAA;AA1CJ;AA6CE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;AA3CJ;AA6CI;EACE,eAAA;AA3CN;AA+CE;EACE,YAAA;AA7CJ;AA+CI;EACE,UAAA;AA7CN;AAgDI;EACE,YAAA;AA9CN;AAkDE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAhDJ;AAkDI;EACE,UAAA;AAhDN;;AAqDA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AAlDF;AAqDE;EACE,eAAA;EACA,gBAAA;AAnDJ;AAuDE;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EACA,aAAA;EACA,eAAA;AArDJ;AAuDI;;EACE,gBAAA;EACA,6BAAA;EACA,eAAA;AApDN;AAuDI;;EACE,+BAAA;AApDN;;AAyDA;EACE,sCAAA;EACA,uCAAA;EACA,kFAAA;EACA,UAAA;EACA,qBAAA;AAtDF;AAwDE;EACE,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,wCAAA;AAtDJ;AAyDE;EACE,qBAAA;AAvDJ;AA0DE;EACE,sCAAA;EACA,uCAAA;AAxDJ;;AA4DA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA,4DAAA;AACA;EACE;IAAW,UAAA;EAxDX;EAyDA;IAAM,UAAA;EAtDN;AACF;AAwDA;EACE,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,uCAAA;EACA,WAAA;EACA,iBAAA;AAtDF;;AAyDA,+BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAtDF;AA0DE;EACE,kBAAA;EACA,yDAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,uDAAA;AAxDJ;AA2DE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAzDJ;AA6DI;EACE,4BAAA;EACA,YAAA;AA3DN;AA6DI;EACE,UAAA;AA3DN;AA+DE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,8CAAA;AA7DJ;AA+DI;EACE,mBAAA;AA7DN;AAgEI;EACE,qBAAA;AA9DN;AAiEI;EACE,qBAAA;AA/DN;;AAqEA;EACE,sBAAA;AAlEF;;AAsEA;EACE,yBAAA;AAnEF;;AAuEA;EACE,yBAAA;AApEF;;AAuEA;EACE;IACE,mBAAA;IACA,YAAA;EApEF;EAsEA;IACE,qBAAA;IACA,UAAA;EApEF;AACF;AAuEA;EACE;IAAW,aAAA;EApEX;EAqEA;IAAW,UAAA;EAlEX;AACF;AAoEA,4BAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAlEF;AAoEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAlEJ;AAoEI;EACE,YAAA;EACA,cAAA;AAlEN;;AAuEA,6BAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mDAAA;EACA,eAAA;AApEF;AAsEE;EACE,UAAA;EACA,mBAAA;AApEJ;AAuEE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;AArEJ;AAwEE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;AAtEJ;AAwEI;EACE,WAAA;AAtEN;;AA2EA,yDAAA;AACA;EACE,eAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAxEF;AA0EE;EACE,aAAA;AAxEJ;;AA4EA,oDAAA;AACA;EACE;IACE,gBAAA;IACA,kBAAA;EAzEF;EA4EA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;EA1EF;EA6EA;IACE,2BAAA;IACA,sBAAA;IACA,gBAAA;EA3EF;EA8EA;IACE,iBAAA;IACA,kBAAA;EA5EF;EA+EA;IACE,eAAA;EA7EF;EAgFA;IACE,eAAA;EA9EF;EAiFA;IACE,cAAA;EA/EF;EAkFA;IACE,eAAA;IACA,kBAAA;IACA,sBAAA;EAhFF;EAqFE;IACE,eAAA;IACA,gBAAA;IACA,sBAAA;EAnFJ;EAsFE;IACE,eAAA;IACA,YAAA;EApFJ;AACF;AAyFA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAvFF;AA0FE;EACE,aAAA;AAxFJ;;AA6FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AA1FF;AA8FI;EACE,aAAA;EACA,QAAA;AA5FN;AA+FI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA7FN;AA+FM;EACE,UAAA;EACA,oCAAA;AA7FR;AAgGM;EACE,UAAA;EACA,oCAAA;AA9FR;AAiGM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA/FR;;AAsGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2DAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAnGF;AAqGE;EACE,mBAAA;EACA,kCAAA;AAnGJ;;AAwGA;EACE,0BAAA;EACA,wBAAA;AArGF;;AA0GA;EACE,0BAAA;EACA,wBAAA;AAvGF;;AA2GA;EACE,0BAAA;EACA,wBAAA;AAxGF;AA0GE;EACE,wBAAA;EACA,kDAAA;AAxGJ;AA2GE;EACE,uBAAA;EACA,kCAAA;AAzGJ;;AA8GA;EACE,sCAAA;AA3GF;;AA8GA;EACE;IAAK,6CAAA;EA1GL;EA2GA;IAAO,gBAAA;EAxGP;AACF;AA2GA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,uCAAA;EACA,8CAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,oBAAA;AAzGF;AA2GE;EACE,iBAAA;EACA,yCAAA;EACA,iBAAA;EACA,kCAAA;EACA,qDAAA;AAzGJ;AA4GE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AA1GJ;;AA+GA;EACE,eAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA5GF;AA8GE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA5GJ;;AAiHA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;AA9GF;;AAiHA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AA9GF;;AAiHA;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,mDAAA;AA9GF;AAgHE;EACE,yBAAA;EACA,qCAAA;AA9GJ;AAiHE;EACE,cAAA;EACA,qCAAA;AA/GJ;AAiHI;EACE,cAAA;EACA,oCAAA;AA/GN;AAmHE;EACE,gCAAA;EACA,oCAAA;AAjHJ;AAoHE;EACE,gCAAA;EACA,oCAAA;AAlHJ;AAqHE;EACE,gCAAA;EACA,oCAAA;AAnHJ;AAsHE;EACE,gCAAA;EACA,oCAAA;AApHJ;AAuHE;EACE,gCAAA;EACA,oCAAA;AArHJ;AAwHE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,qCAAA;EACA,0CAAA;AAtHJ;;AA0HA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AAvHF;;AA0HA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;AAvHF;AAyHE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvHJ;AA0HE;EACE,UAAA;EACA,kCAAA;AAxHJ;;AA4HA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qDAAA;EACA,UAAA;AAzHF;AA2HE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAzHJ;AA4HE;EACE,oCAAA;AA1HJ;AA4HI;EACE,YAAA;AA1HN;;AAgIA;EACE,UAAA;AA7HF;;AAkIE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA/HJ;;AAoIA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;AAjIF;;AAoIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,qEAAA;EACA,yDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,0DAAA;EACA,yBAAA;UAAA,iBAAA;AAjIF;AAmIE;EACE,4CAAA;EACA,yDAAA;AAjIJ;AAoIE;EACE,+EAAA;AAlIJ;AAqIE;EACE,eAAA;EACA,cAAA;AAnIJ;AAsIE;EACE,kBAAA;EACA,YAAA;AApIJ;;AAwIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qEAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qDAAA;EACA,UAAA;AArIF;AAuIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AArIJ;AAwIE;EACE,wDAAA;AAtIJ;AAwII;EACE,YAAA;AAtIN;;AA4IA;EACE,gCAAA;EACA,qCAAA;AAzIF;AA2IE;EACE,gCAAA;EACA,qCAAA;AAzIJ;AA4IE;EACE,cAAA;EACA,oCAAA;AA1IJ;AA6IE;EACE,oCAAA;EACA,sCAAA;AA3IJ;;AA+IA;EACE,sCAAA;AA5IF;AA8IE;EACE,+BAAA;AA5IJ;AA+IE;EACE,qCAAA;AA7IJ;;AAiJA;EACE,YAAA;AA9IF;;AAkJA;EACE,oCAAA;EACA,sCAAA;AA/IF;AAiJE;EACE,oCAAA;EACA,sCAAA;AA/IJ;AAkJE;EACE,oCAAA;EACA,sCAAA;AAhJJ;;AAoJA;EACE,sCAAA;AAjJF;AAmJE;EACE,+BAAA;AAjJJ;AAoJE;EACE,qCAAA;AAlJJ;;AAuJA;EACE,UAAA;AApJF;;AAwJA;EACE,UAAA;AArJF;;AAwJA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,oEAAA;EACA,yCAAA;EACA,WAAA;AArJF;AAuJE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,qDAAA;AArJJ;AAuJI;EACE,yDAAA;EACA,sBAAA;AArJN;AAwJI;EACE,+EAAA;AAtJN;;AA8JA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,WAAA;AA3JF;AA6JE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3JJ;AA8JE;EACE,qBAAA;EACA,yCAAA;AA5JJ;AA+JE;EACE,sBAAA;AA7JJ;AAiKE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AA/JJ;;AAqKE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mEAAA;EACA,2EAAA;AAlKJ;AAqKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAnKJ;AAqKI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnKN;AAsKI;EACE,UAAA;AApKN;;AA0KA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvKF;;AA0KA;EAEE,qDAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mDAAA;AAzKF;AA2KE;EACE,aAAA;AAzKJ;AA6KE;EACE,qDAAA;AA3KJ;AA8KE;EACE,8BAAA;AA5KJ;AA+KE;EACE,8BAAA;AA7KJ;AAgLE;EACE,aAAA;EACA,mBAAA;AA9KJ;AAiLE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iCAAA;EACA,aAAA;AA/KJ;AAkLE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhLJ;AAmLE;EACE,OAAA;EACA,YAAA;AAjLJ;AAoLE;EACE,eAAA;EACA,gBAAA;AAlLJ;AAqLE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAnLJ;AAsLE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AApLJ;AAuLE;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AArLJ;AAwLE;EACE,eAAA;EACA,YAAA;EACA,aAAA;AAtLJ;;AA0LA,6EAAA;AACA;EAAwB,eAAA;AAtLxB;;AAuLA;EAAmB,mCAAA;AAnLnB;;AAoLA;EACE;IAAK,oCAAA;EAhLL;EAiLA;IAAO,uBAAA;EA9KP;AACF","sourcesContent":["@import '../../../styles/breakpoints';\n\n:host {\n  font-family:\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Open Sans',\n    'Helvetica Neue',\n    sans-serif;\n  display: flex;\n  overflow: auto;\n  position: relative;  // For scroll-to-bottom button positioning\n}\n\n:host,\n.content {\n  flex: 1 1 0%;\n}\n\n.content {\n  margin-right: 7px;\n  overflow: auto;\n  // Disable browser scroll anchoring - it causes erratic jumps when DOM changes\n  // (e.g., when streaming completes and message switches from raw to markdown)\n  overflow-anchor: none;\n}\n\n.embed {\n  .convo {\n    padding: 0;\n  }\n\n  .turn {\n    padding: 1rem 0.25rem 0;\n  }\n}\n\n.convo {\n  display: flex;\n  flex-direction: column;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  // Extra bottom padding compensates for scroll container shrinking when\n  // the textarea input grows. Dynamically updated by setContentPaddingBottom().\n  padding-bottom: 1rem;\n}\n\n.load-more-container {\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n\n  .load-more-button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n\n    mat-spinner {\n      margin-right: 0.25rem;\n    }\n  }\n}\n\n.turn {\n  padding: calc(var(--density-spacing, 1rem) + 2px) 0px;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  .streaming-cursor {\n    white-space: pre-wrap;\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  @include respond-to(xl) {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n\n  @include respond-to(lg) {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n\n  @include respond-to(md) {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n}\n\n.center-col {\n  margin: 0 auto;\n  width: 100%;\n  max-width: var(--message-max-width, 800px);\n  display: flex;\n  justify-content: flex-start;\n  gap: var(--density-spacing, 1rem);\n\n  &.self {\n    justify-content: flex-end;\n  }\n\n  @include respond-to(lg) {\n    gap: calc(var(--density-spacing, 1rem) + 0.5rem);\n  }\n\n  @include respond-to(md) {\n    gap: calc(var(--density-spacing, 1rem) + 0.25rem);\n  }\n}\n\n.other-gutter {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  border-radius: 50%;\n  border-width: 1px;\n  border-style: solid;\n\n  padding: 6px;\n  height: 32px;\n  width: 32px;\n  font-size: 18px;\n  line-height: 18px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.self-message {\n  padding: 0.652rem 1.25rem;\n  border-radius: 1.5rem;\n  max-width: 70%;\n}\n\n.other-message {\n  padding-top: 4px;\n\n  &.error {\n    color: unset;\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 0.5rem;\n    padding: 0.25rem 0.5rem;\n  }\n}\n\n/* Error container for messages that ended with errors */\n.error-container {\n  width: 100%;\n\n  .error-banner {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    margin-top: 12px;\n    border-radius: 4px;\n    font-size: 0.85rem;\n    font-weight: 500;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n/* Light theme error banner */\n:host-context(.light-theme) .error-banner,\n.error-banner {\n  background-color: #fdecea;\n  color: #c62828;\n  border: 1px solid #f5c6cb;\n}\n\n/* Dark theme error banner */\n:host-context(.dark) .error-banner {\n  background-color: rgba(198, 40, 40, 0.15);\n  color: #ef9a9a;\n  border: 1px solid rgba(198, 40, 40, 0.3);\n}\n\n/* Cancelled container — same layout as error but amber tint */\n.cancelled-container {\n  width: 100%;\n\n  .cancelled-banner {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    margin-top: 12px;\n    border-radius: 4px;\n    font-size: 0.85rem;\n    font-weight: 500;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n:host-context(.light-theme) .cancelled-banner,\n.cancelled-banner {\n  background-color: #fff8e1;\n  color: #f57f17;\n  border: 1px solid #ffe082;\n}\n\n:host-context(.dark) .cancelled-banner {\n  background-color: rgba(255, 160, 0, 0.12);\n  color: #ffcc80;\n  border: 1px solid rgba(255, 160, 0, 0.3);\n}\n\n.title {\n  font-weight: bold;\n}\n\nhr {\n  width: 80%;\n  border-top: 1px solid #eee;\n  margin-bottom: 30px;\n  margin-top: 0;\n}\n\n.timestamp {\n  font-size: 0.75rem;\n  color: #999;\n  margin-left: 8px;\n}\n\n.title {\n  display: flex;\n  align-items: center; // Ensures proper vertical alignment\n}\n\n.flex-spacer {\n  flex-grow: 1; // Pushes the timestamp to the right\n  min-width: 0; // Allow shrinking in flex context\n}\n\n.timestamp {\n  font-size: 0.85rem; // Adjust font size for better readability\n  color: #888; // Light gray for a subtle effect\n}\n\n/* ---- MESSAGE BUBBLE STYLING ---- */\n.message-bubble {\n  position: relative; // For absolute-positioned children (e.g. sleep-mode icon)\n  padding: 0.652rem 1.25rem;\n  border-radius: 1.5rem;\n  word-break: break-word;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0; // Allow shrinking in flex context\n  overflow: hidden; // Contain children\n\n  &.self-message {\n    max-width: 70%;\n  }\n\n}\n\n// Status divider — centered inline event (e.g. sleep mode)\n.status-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 4px 0;\n  opacity: 0.5;\n  font-size: 0.75rem;\n  user-select: none;\n\n  .material-icons {\n    font-size: 14px;\n  }\n\n  .status-text {\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .status-time {\n    opacity: 0.7;\n    &::before {\n      content: '·';\n      margin-right: 6px;\n    }\n  }\n}\n\n.self-message {\n  background: #e3f2fd; /* Light blue for self messages */\n}\n\n.other-message {\n  background: #f5f5f5; /* Light gray for others */\n}\n\n/* ---- HEADER STYLING (Title, Timestamp, Copy Button) ---- */\n.message-header {\n  display: flex;\n  align-items: center;\n  padding-bottom: 4px;\n  min-width: 0; // Allow shrinking in flex context\n  overflow: hidden; // Contain children\n}\n\n.title-text {\n  font-weight: bold;\n}\n\n.flex-spacer {\n  flex-grow: 1;\n  min-width: 0; // Allow shrinking in flex context\n}\n\n.timestamp {\n  font-size: 0.85rem;\n  color: #888;\n}\n\n.model {\n  font-size: 0.85rem;\n  color: #888;\n}\n\n.copy-button {\n  --square-button-size: 30px;\n  --square-icon-size: 15px;\n}\n\n// Promoted header favorites — small inline items between spacer and timestamp\n.header-fav {\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  font-size: 0.8rem;\n  opacity: 1;\n  padding: 2px 6px;\n  border-radius: 4px;\n  user-select: none;\n  display: inline-flex;\n  align-items: center;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n\n  .fav-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n\n    &.pin-active {\n      color: var(--tool-accent, #1976d2);\n      opacity: 1;\n    }\n  }\n\n  &.agent-badge {\n    color: var(--tool-accent, #1976d2);\n    font-weight: 500;\n    font-family: inherit;\n  }\n\n  &.orchestration-badge {\n    color: var(--orchestration-accent, #ab47bc);\n    font-weight: 500;\n    font-family: inherit;\n  }\n\n  &[class*=\"-badge\"]:not(.duration-badge):not(.tokens-badge):not(.model-badge):not(.agent-badge) {\n    cursor: pointer;\n    &:hover {\n      opacity: 0.9;\n      background-color: rgba(128, 128, 128, 0.15);\n    }\n  }\n\n  // First-content half of the latency chip — dimmed so first-byte reads primary.\n  &.duration-badge .fcp-secondary {\n    opacity: 0.5;\n    font-weight: 400;\n  }\n}\n\n// Kebab menu — favorite star toggles\n::ng-deep .fav-menu-item {\n  // Override Material's internal text wrapper to allow flex layout across full width\n  .mdc-list-item__primary-text,\n  .mat-mdc-menu-item-text {\n    display: flex !important;\n    align-items: center;\n    width: 100%;\n    gap: 4px;\n  }\n\n  .fav-spacer {\n    flex: 1 1 0;\n    min-width: 8px;\n  }\n\n  .reorder-arrow {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n\n    &.disabled {\n      cursor: default;\n    }\n  }\n\n  &:hover .reorder-arrow {\n    opacity: 0.3;\n\n    &:hover:not(.disabled) {\n      opacity: 1;\n    }\n\n    &.disabled {\n      opacity: 0.1;\n    }\n  }\n\n  .fav-star {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.35;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.message-content {\n  padding-top: 4px;\n  min-width: 0; // Allow shrinking in flex context\n  overflow-x: auto; // Scroll if content overflows\n\n  // Ensure code blocks scroll horizontally instead of expanding container\n  ::ng-deep pre {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n\n  // File attachment links — styled as visible chips\n  ::ng-deep a[href*=\"/channel-uploads/\"]:not([href$=\".png\"]):not([href$=\".jpg\"]):not([href$=\".jpeg\"]):not([href$=\".gif\"]):not([href$=\".webp\"]),\n  ::ng-deep a[href*=\"/uploads/\"]:not([href$=\".png\"]):not([href$=\".jpg\"]):not([href$=\".jpeg\"]):not([href$=\".gif\"]):not([href$=\".webp\"]) {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 14px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.15);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    color: inherit !important;\n    text-decoration: none !important;\n    font-size: 0.9em;\n    font-weight: 500;\n    transition: background 0.15s ease;\n    margin: 4px 0;\n    cursor: pointer;\n\n    &::before {\n      content: '\\e226';\n      font-family: 'Material Icons';\n      font-size: 18px;\n    }\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.22);\n    }\n  }\n}\n\n.square-button {\n  width: var(--square-button-size, 48px);\n  height: var(--square-button-size, 48px);\n  padding: calc(var(--square-button-size, 48px) / 2 - var(--square-icon-size, 24px));\n  padding: 0;\n  border-radius: 0.5rem;\n\n  mat-icon {\n    width: var(--square-icon-size, 24px);\n    height: var(--square-icon-size, 24px);\n    line-height: var(--square-icon-size, 24px);\n    font-size: var(--square-icon-size, 24px);\n  }\n\n  ::ng-deep .mat-mdc-button-persistent-ripple {\n    border-radius: 0.5rem;\n  }\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: var(--square-button-size, 48px);\n    height: var(--square-button-size, 48px);\n  }\n}\n\n.wide {\n  width: calc(100%);\n  min-width: 700px;\n  height: auto;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.hidden {\n  display: none;\n}\n\n/* Add animation for the blinking cursor in streaming text */\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0; }\n}\n\n.streaming-cursor::after {\n  content: '|';\n  display: inline-block;\n  margin-left: 2px;\n  animation: blink 1s step-start infinite;\n  color: #444;\n  font-weight: bold;\n}\n\n/* Typing indicator animation */\n.typing-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24px;\n  padding: 8px 12px;\n  cursor: pointer;\n  position: relative;\n\n  // Verbatim terminal spinner line (verb + glyph + status), shown during the\n  // think-gap. Monospace + muted so it reads as the real terminal output.\n  .spinner-line {\n    margin-right: auto; // left-align within the centered flex row\n    font-family: 'SF Mono', 'Roboto Mono', 'Menlo', monospace;\n    font-size: 0.85em;\n    color: #9aa0a6;\n    white-space: pre-wrap;\n    word-break: break-word;\n    animation: spinner-line-pulse 1.6s ease-in-out infinite;\n  }\n\n  .stop-icon {\n    position: absolute;\n    right: 4px;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    opacity: 0;\n    color: #999;\n    transition: opacity 0.15s;\n  }\n\n  &:hover {\n    .dot {\n      animation-play-state: paused;\n      opacity: 0.3;\n    }\n    .stop-icon {\n      opacity: 1;\n    }\n  }\n\n  .dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: #888;\n    margin: 0 4px;\n    opacity: 0.6;\n    animation: dot-pulse 1.5s ease-in-out infinite;\n\n    &:nth-child(1) {\n      animation-delay: 0s;\n    }\n\n    &:nth-child(2) {\n      animation-delay: 0.3s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 0.6s;\n    }\n  }\n}\n\n// Connecting: muted gray (infrastructure wiring up, pre-Claude)\n.typing-indicator--connecting .dot {\n  background-color: #bbb;\n}\n\n// Generating: primary blue (reached Claude, awaiting first token)\n.typing-indicator--generating .dot {\n  background-color: #1976d2;\n}\n\n// Stalled: amber (API delayed >30s)\n.typing-indicator--stalled .dot {\n  background-color: #ff9800;\n}\n\n@keyframes dot-pulse {\n  0%, 60%, 100% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  30% {\n    transform: scale(1.5);\n    opacity: 1;\n  }\n}\n\n@keyframes spinner-line-pulse {\n  0%, 100% { opacity: 0.55; }\n  50%      { opacity: 1; }\n}\n\n/* ---- READ RECEIPTS ---- */\n.read-receipt {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 4px;\n  margin-top: -2px;\n\n  .receipt-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    opacity: 0.35;\n    color: inherit;\n\n    &.read {\n      opacity: 0.8;\n      color: #4caf50;\n    }\n  }\n}\n\n/* ---- IMAGE LIGHTBOX ---- */\n.image-lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n  cursor: pointer;\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  img {\n    max-width: 90%;\n    max-height: 90%;\n    object-fit: contain;\n    border-radius: 4px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  }\n\n  .image-lightbox-close {\n    position: absolute;\n    top: 20px;\n    right: 30px;\n    font-size: 40px;\n    color: white;\n    cursor: pointer;\n    transition: color 0.2s ease;\n    line-height: 1;\n\n    &:hover {\n      color: #ccc;\n    }\n  }\n}\n\n/* Make images in messages clickable and properly sized */\n.message-content ::ng-deep img {\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 400px;\n  object-fit: contain;\n  border-radius: 8px;\n\n  &:hover {\n    opacity: 0.85;\n  }\n}\n\n/* Mobile responsive - prevent horizontal overflow */\n@media (max-width: 768px) {\n  :host {\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n\n  .content {\n    margin-right: 0;\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n\n  .wide {\n    min-width: unset !important;\n    width: 100% !important;\n    max-width: 100vw;\n  }\n\n  .turn {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .center-col {\n    max-width: 100%;\n  }\n\n  .message-bubble {\n    max-width: 100%;\n  }\n\n  .self-message {\n    max-width: 85%;\n  }\n\n  .other-message {\n    max-width: 100%;\n    overflow-x: hidden;\n    word-break: break-word;\n  }\n\n  // Ensure code blocks don't overflow\n  .message-content ::ng-deep {\n    pre, code {\n      max-width: 100%;\n      overflow-x: auto;\n      word-break: break-word;\n    }\n\n    img {\n      max-width: 100%;\n      height: auto;\n    }\n  }\n}\n\n// Widget container - hides titlebar when embedded in chat\n.widget-container {\n  position: relative;\n  height: 400px;\n  min-height: 200px;\n  max-height: none; // Override .wide's max-height: 600px\n  resize: vertical;\n  overflow: auto;\n\n  // Widget titlebar is hidden - its content is moved to the message header\n  ::ng-deep app-widget-titlebar {\n    display: none;\n  }\n}\n\n// Toolbar slot in message header for widget custom controls\n.widget-toolbar-slot {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-right: 8px;\n\n  // Style buttons moved from widget titlebar\n  ::ng-deep {\n    .tab-buttons {\n      display: flex;\n      gap: 2px;\n    }\n\n    button {\n      width: 24px;\n      height: 24px;\n      padding: 0;\n      border: none;\n      background: transparent;\n      border-radius: 4px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      opacity: 0.7;\n\n      &:hover {\n        opacity: 1;\n        background: rgba(128, 128, 128, 0.2);\n      }\n\n      &.active {\n        opacity: 1;\n        background: rgba(128, 128, 128, 0.3);\n      }\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        line-height: 16px;\n      }\n    }\n  }\n}\n\n// Loading overlay while capturing initial screenshot\n.widget-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--surface-color, rgba(255, 255, 255, 0.95));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  z-index: 10;\n\n  span {\n    font-size: 0.875rem;\n    color: var(--text-secondary, #666);\n  }\n}\n\n// Kebab menu trigger — always visible\n.kebab-button {\n  --square-button-size: 30px;\n  --square-icon-size: 15px;\n}\n\n\n// Snapshot button in header (styled like copy button)\n.snapshot-button {\n  --square-button-size: 30px;\n  --square-icon-size: 15px;\n}\n\n// Pin button\n.pin-button {\n  --square-button-size: 30px;\n  --square-icon-size: 15px;\n\n  mat-icon {\n    transform: rotate(45deg);\n    transition: transform 0.15s ease, color 0.15s ease;\n  }\n\n  &.pin-active mat-icon {\n    transform: rotate(0deg);\n    color: var(--tool-accent, #1976d2);\n  }\n}\n\n// Highlight flash when seeking to a pinned message\n.turn.highlight-flash .message-bubble {\n  animation: highlight-pulse 2s ease-out;\n}\n\n@keyframes highlight-pulse {\n  0% { box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.4); }\n  100% { box-shadow: none; }\n}\n\n// Snapshot preview popup\n.snapshot-preview {\n  position: fixed;\n  z-index: 1000;\n  width: 200px;\n  background: var(--surface-color, white);\n  border: 1px solid var(--border-color, #e0e0e0);\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  pointer-events: none;\n\n  .preview-label {\n    padding: 6px 10px;\n    background: var(--surface-color, #f5f5f5);\n    font-size: 0.7rem;\n    color: var(--text-secondary, #666);\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n  }\n\n  img {\n    display: block;\n    width: 100%;\n    height: auto;\n    max-height: 150px;\n    object-fit: cover;\n  }\n}\n\n// Widget screenshot styling (for persisted screenshots)\n.widget-screenshot {\n  margin-top: 8px;\n  border: 1px solid var(--border-color, #e0e0e0);\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: default;\n\n  img {\n    display: block;\n    width: 100%;\n    height: auto;\n  }\n}\n\n// ---- MESSAGE FOOTER (tags + reactions on one line) ----\n.message-footer {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.links-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.link-tag {\n  display: inline-block;\n  font-size: 11px;\n  color: rgba(140, 180, 220, 0.85);\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: rgba(140, 180, 220, 0.1);\n  cursor: pointer;\n  letter-spacing: 0.02em;\n  transition: color 0.15s ease, background 0.15s ease;\n\n  &:hover {\n    color: rgba(140, 180, 220, 1);\n    background: rgba(140, 180, 220, 0.18);\n  }\n\n  &.backlog-tag {\n    color: #ffc777;\n    background: rgba(255, 199, 119, 0.12);\n\n    &:hover {\n      color: #ffd89e;\n      background: rgba(255, 199, 119, 0.2);\n    }\n  }\n\n  &.concept-tag {\n    color: rgba(100, 180, 255, 0.85);\n    background: rgba(100, 180, 255, 0.1);\n  }\n\n  &.product-tag {\n    color: rgba(130, 220, 160, 0.85);\n    background: rgba(130, 220, 160, 0.1);\n  }\n\n  &.people-tag {\n    color: rgba(255, 180, 130, 0.85);\n    background: rgba(255, 180, 130, 0.1);\n  }\n\n  &.ticket-tag {\n    color: rgba(220, 140, 255, 0.85);\n    background: rgba(220, 140, 255, 0.1);\n  }\n\n  &.channel-tag {\n    color: rgba(100, 220, 220, 0.85);\n    background: rgba(100, 220, 220, 0.1);\n  }\n\n  &.editing {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    padding: 1px 4px;\n    background: rgba(140, 180, 220, 0.15);\n    border: 1px solid rgba(140, 180, 220, 0.3);\n  }\n}\n\n.tag-edit-input {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: inherit;\n  font-size: 11px;\n  font-family: inherit;\n  letter-spacing: 0.02em;\n  width: 120px;\n  padding: 0;\n}\n\n.tag-delete-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  opacity: 0.5;\n  border-radius: 50%;\n  transition: opacity 0.15s ease, background 0.15s ease;\n\n  mat-icon {\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n    line-height: 12px;\n  }\n\n  &:hover {\n    opacity: 1;\n    background: rgba(255, 80, 80, 0.2);\n  }\n}\n\n.add-tag-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1px dashed rgba(140, 180, 220, 0.3);\n  background: transparent;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, background 0.15s ease;\n  padding: 0;\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    line-height: 14px;\n    opacity: 0.5;\n  }\n\n  &:hover {\n    background: rgba(140, 180, 220, 0.1);\n\n    mat-icon {\n      opacity: 0.9;\n    }\n  }\n}\n\n// Show add-tag button on message hover\n.message-bubble:hover .add-tag-btn {\n  opacity: 1;\n}\n\n// Compact autocomplete dropdown for tag editing\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel {\n  .mat-mdc-option {\n    font-size: 11px;\n    min-height: 28px;\n    padding: 0 10px;\n    line-height: 28px;\n  }\n}\n\n// ---- REACTIONS ----\n.reactions-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.reaction-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  border: 1px solid var(--preset-text-muted, rgba(128, 128, 128, 0.25));\n  background: var(--preset-code, rgba(128, 128, 128, 0.08));\n  cursor: pointer;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  transition: border-color 0.15s ease, background 0.15s ease;\n  user-select: none;\n\n  &:hover {\n    border-color: var(--preset-primary, #2aa198);\n    background: var(--preset-card, rgba(128, 128, 128, 0.15));\n  }\n\n  &.mine {\n    background: color-mix(in srgb, var(--preset-primary, #2aa198) 12%, transparent);\n  }\n\n  .reaction-emoji {\n    font-size: 1rem;\n    line-height: 1;\n  }\n\n  .reaction-count {\n    font-size: 0.75rem;\n    opacity: 0.7;\n  }\n}\n\n.add-reaction-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1px dashed var(--preset-text-muted, rgba(128, 128, 128, 0.3));\n  background: transparent;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, background 0.15s ease;\n  padding: 0;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    opacity: 0.5;\n  }\n\n  &:hover {\n    background: var(--preset-code, rgba(128, 128, 128, 0.1));\n\n    mat-icon {\n      opacity: 0.9;\n    }\n  }\n}\n\n// Link tags on user (self) messages need lighter backgrounds\n.self-message .link-tag {\n  color: rgba(255, 255, 255, 0.75);\n  background: rgba(255, 255, 255, 0.15);\n\n  &:hover {\n    color: rgba(255, 255, 255, 0.95);\n    background: rgba(255, 255, 255, 0.25);\n  }\n\n  &.backlog-tag {\n    color: #ffc777;\n    background: rgba(255, 199, 119, 0.2);\n  }\n\n  &.editing {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.4);\n  }\n}\n\n.self-message .add-tag-btn {\n  border-color: rgba(255, 255, 255, 0.3);\n\n  mat-icon {\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.15);\n  }\n}\n\n.self-message .tag-edit-input {\n  color: white;\n}\n\n// Reaction pills on user (self) messages need lighter backgrounds\n.self-message .reaction-pill {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n\n  &.mine {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n}\n\n.self-message .add-reaction-btn {\n  border-color: rgba(255, 255, 255, 0.3);\n\n  mat-icon {\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.15);\n  }\n}\n\n// Show add-reaction button on message hover\n.message-bubble:hover .add-reaction-btn {\n  opacity: 1;\n}\n\n// Also show when picker is open\n.reactions-row:has(.reaction-picker) .add-reaction-btn {\n  opacity: 1;\n}\n\n.reaction-picker {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 4px 8px;\n  border-radius: 20px;\n  background: var(--preset-card, #fff);\n  border: 1px solid var(--preset-text-muted, rgba(128, 128, 128, 0.2));\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  z-index: 10;\n\n  .picker-emoji {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 1.15rem;\n    transition: background 0.1s ease, transform 0.1s ease;\n\n    &:hover {\n      background: var(--preset-code, rgba(128, 128, 128, 0.12));\n      transform: scale(1.15);\n    }\n\n    &.selected {\n      background: color-mix(in srgb, var(--preset-primary, #2aa198) 15%, transparent);\n    }\n  }\n}\n\n// .md-path-btn styles are in global styles.scss (directive creates elements outside Angular encapsulation)\n\n// Scroll to bottom button (readback mode indicator)\n.scroll-to-bottom-btn {\n  position: absolute;\n  bottom: 30px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--primary-color, #1976d2);\n  color: white;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s, box-shadow 0.2s;\n  z-index: 50;\n\n  mat-icon {\n    font-size: 28px;\n    width: 28px;\n    height: 28px;\n  }\n\n  &:hover {\n    transform: scale(1.1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  // Badge for new content count\n  .new-content-badge {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    min-width: 20px;\n    height: 20px;\n    padding: 0 6px;\n    border-radius: 10px;\n    background: #f44336;\n    color: white;\n    font-size: 12px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n}\n\n// Truncated message preview card\n.truncated-card {\n  .truncated-preview {\n    max-height: 200px;\n    overflow: hidden;\n    position: relative;\n    mask-image: linear-gradient(to bottom, black 60%, transparent 100%);\n    -webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);\n  }\n\n  .truncated-expand-btn {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 8px;\n    font-size: 12px;\n    opacity: 0.8;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n// Channel action cards (work session proposals, etc.)\n.channel-actions {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.channel-action-card {\n  // Left accent border — override --action-accent-color per card type\n  --action-accent-color: var(--preset-primary, #5b8dd9);\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 14px;\n  border-left: 3px solid var(--action-accent-color);\n  border-radius: 6px;\n  background: var(--preset-card, rgba(0, 0, 0, 0.04));\n\n  &.channel-action-card--dismissed {\n    display: none;\n  }\n\n  // Per-type accent colors (Lais can override these)\n  &.channel-action-card--work-session {\n    --action-accent-color: var(--preset-primary, #5b8dd9);\n  }\n\n  &.channel-action-card--reopen-session {\n    --action-accent-color: #8a8a8a;\n  }\n\n  &.channel-action-card--unarchive-channel {\n    --action-accent-color: #8a8a8a;\n  }\n\n  .action-header {\n    display: flex;\n    align-items: center;\n  }\n\n  .action-type-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--action-accent-color);\n    opacity: 0.75;\n  }\n\n  .action-type-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n  }\n\n  .action-body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .action-title {\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .action-summary {\n    font-size: 12px;\n    opacity: 0.6;\n    margin-top: 3px;\n    line-height: 1.4;\n  }\n\n  .action-buttons {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  .action-btn--primary {\n    font-size: 12px;\n    height: 30px;\n    line-height: 30px;\n    color: white !important;\n  }\n\n  .action-btn--dismiss {\n    font-size: 12px;\n    height: 30px;\n    opacity: 0.45;\n  }\n}\n\n/* Read receipt of a follow-up folded into an earlier reply: clickable jump */\n.read-receipt.handled { cursor: pointer; }\n.turn.jump-flash { animation: jump-flash 1.6s ease-out; }\n@keyframes jump-flash {\n  0% { background: rgba(76, 110, 245, 0.18); }\n  100% { background: transparent; }\n}\n","$breakpoints: (\n  'xs': 0px,\n  'sm': 576px,\n  'md': 768px,\n  'lg': 992px,\n  'xl': 1200px,\n  'xxl': 1400px,\n  'xxxl': 2100px\n) !default;\n\n@mixin respond-to($breakpoint) {\n  @if map-has-key($breakpoints, $breakpoint) {\n    @media (min-width: map-get($breakpoints, $breakpoint)) {\n      @content;\n    }\n  } @else {\n    @warn \"Unfortunately, no value could be retrieved from `#{$breakpoint}`. Available breakpoints are: #{map-keys($breakpoints)}.\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
